export class SessionViewModel {
    userId: number;
    name: string;
    cpfNumber: string;
    email: string;
    activeFlag: boolean;
    renewPasswordFlag: string;
    imobiliariaId: number;
    planoId: number;
    perfilId: number;
    termosAceitos: string;
    onboardingConcluido: string;
    urlFotoPerfil?: string;

    userPicture: string;
    dateLastAccessLogin: Date;

    constructor(p: any) {
        this.userId = p.userId !== undefined ? p.userId : null;
        this.name = p.name !== undefined ? p.name : null;
        this.cpfNumber = p.cpfNumber !== undefined ? p.cpfNumber : null;
        this.email = p.email !== undefined ? p.email : null;
        this.activeFlag = p.activeFlag !== undefined ? p.activeFlag : null;
        this.renewPasswordFlag = p.renewPasswordFlag !== undefined ? p.renewPasswordFlag : null;
        this.imobiliariaId = p.imobiliariaId !== undefined ? p.imobiliariaId : null;
        this.planoId = p.planoId !== undefined ? p.planoId : null;
        this.perfilId = p.perfilId !== undefined ? p.perfilId : null;
        this.termosAceitos = p.termosAceitos !== undefined ? p.termosAceitos : null;
        this.onboardingConcluido = p.onboardingConcluido !== undefined ? p.onboardingConcluido : null;
        this.urlFotoPerfil = p.urlFotoPerfil !== undefined ? p.urlFotoPerfil : null;

        this.userPicture = p.userPicture !== undefined ? p.userPicture : null;
        this.dateLastAccessLogin = p.dateLastAccessLogin !== undefined ? p.dateLastAccessLogin : null;
    }

}